/**
 * Client-side guard for OAuth / auth URLs coming from the server or from
 * persisted chat cards. If a URL points at an internal bind address
 * (0.0.0.0, localhost, 127.0.0.1 — e.g. links minted before the proxy-origin
 * fix), re-home it onto the site the user is actually on.
 */

const INTERNAL_HOST = /^(0\.0\.0\.0|127\.0\.0\.1|localhost|\[::1?\])$/i

export function toPublicAppUrl(url: string, origin?: string): string {
  const currentOrigin =
    origin || (typeof window !== 'undefined' ? window.location.origin : '')
  if (!url || !currentOrigin) return url

  try {
    const parsed = new URL(url, currentOrigin)
    const current = new URL(currentOrigin)
    // Local development legitimately runs on localhost — only re-home when the
    // app itself is on a public host.
    if (INTERNAL_HOST.test(parsed.hostname) && !INTERNAL_HOST.test(current.hostname)) {
      return `${current.origin}${parsed.pathname}${parsed.search}${parsed.hash}`
    }
    return parsed.toString()
  } catch {
    return url
  }
}
